<template>
    <v-card id="funding" elevation="4" class="mb-8">
        <v-toolbar color="green darken-4" dark flat dense>
            <v-toolbar-title>Your Higher Edcation (HE) Funding</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-scroll-to="'#top'" dark text>
                <v-icon left>fas fa-chevron-up</v-icon>
                Top
            </v-btn>
            <span v-scroll-to="'#kickers'" class="fa-stack fa-md icon-info">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-info fa-stack-1x"></i>
            </span>
        </v-toolbar>
        <v-card-text>
            <p>It is your responsibility to apply for funding directly to Student Awards Agency Scotland (SAAS).  Even if you dont want a loan, you must apply for your fees.</p>
            <h4>The courses below are the ones you have applied for that fall into this category of funding:</h4>
            <v-card v-for="enrolment in HEEnrolments" :key="enrolment.EnrolmentID" class="mb-4" outlined>
                <v-card-title>
                    <span class="body-1">{{ enrolment.CourseCode }} - {{ enrolment.CourseName }}</span>
                </v-card-title>
            </v-card>
        </v-card-text>
        <v-card-actions>
            <v-btn href="https://saas.gov.uk/full_time/" target="_blank" color="info" dark small style="color:white !important">
                <v-icon left small>fas fa-money-bill-wave</v-icon>
                Student Awards Agency Scotland
            </v-btn>
            <v-btn href="https://heretohelp.dundeeandangus.ac.uk/here-to-help-app-fund/funding/higher-education-funding/" target="_blank" color="info" dark small style="color:white !important">
                <v-icon left small>fas fa-info-circle</v-icon>
                Funding Information
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'

    export default {
        props: ['enrolments'],
        mixins: [enrolmentsMixin],
    }
</script>
